// extracted by mini-css-extract-plugin
export default {"outer_pop":"style_outer_pop__vDguA","bg_pop":"style_bg_pop__-KqMO","inner_pop":"style_inner_pop__U8M-d","close_button":"style_close_button__gYip+"};